/**
 * Link 与 SkipLink（08 开发文档清单）。
 * Link：站内路由感知（React Router Link），外链安全属性自动补齐。
 */
import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link as RouterLink } from 'react-router';

/** 站内/外链统一入口：http(s) 开头走 <a target=_blank rel=noopener>，否则 React Router */
export const Link = forwardRef<HTMLAnchorElement, AnchorHTMLAttributes<HTMLAnchorElement>>(
  function Link({ href, children, ...rest }, ref) {
    if (!href) return <a ref={ref} {...rest}>{children}</a>;
    if (/^https?:\/\//i.test(href)) {
      return (
        <a ref={ref} href={href} target='_blank' rel='noopener noreferrer' {...rest}>
          {children}
        </a>
      );
    }
    return (
      <RouterLink ref={ref} to={href} {...rest}>
        {children}
      </RouterLink>
    );
  },
);

/** 跳过导航直达主内容（a11y 基线：第一个可聚焦元素） */
export function SkipLink({ targetId = 'main' }: { targetId?: string }) {
  return (
    <a className='cs-skip-link' href={`#${targetId}`}>
      跳到主要内容
    </a>
  );
}
